<template>
  <div class="login">
    <div class="login-container" :style="'background-image:url(' + bgimg + ')'">
      <transition name="fade" mode="out-in">
        <div class="login_box" v-if="islogin" key="login">
          <h1 class="title">登录到你的账户</h1>
          <div class="tips">
            没有账户？
            <span class="link" @click="islogin = !islogin">
              前往注册
              <i class="iconfont icon-xiangyou"></i>
            </span>
          </div>
          <div class="forms">
            <Minput
              type="Number"
              class="input phone_input"
              v-model="forms.username"
              icon="icon-yonghuming"
              placeholder="请输入账号(纯数字)"
            />
            <Minput
              type="password"
              v-model="forms.password"
              class="input password_input"
              icon="icon-shurumima"
              placeholder="请输入密码(6-20位字符)"
            />
          </div>
          <p class="tips lost-pwd">忘记密码？</p>
          <div class="submit_box">
            <MButton
              class="submit"
              :loading="loading"
              :disabled="!canISubmit"
              @click="login()"
            >
              登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
            </MButton>
          </div>
        </div>
        <div class="login_box" v-else key="register">
          <h1 class="title">注册账号</h1>
          <div class="tips">
            已有账户？
            <span class="link" @click="islogin = !islogin">
              前往登录
              <i class="iconfont icon-xiangyou"></i>
            </span>
          </div>
          <div class="forms">
            <Minput
              type="text"
              class="input phone_input"
              v-model="forms.username"
              icon="icon-yonghuming"
              placeholder="请输入账号/邮箱"
            />
            <Minput
              type="password"
              v-model="forms.password"
              class="input password_input"
              icon="icon-shurumima"
              placeholder="请输入密码(6-20位字符)"
            />
            <Minput
              type="password"
              v-model="forms.repassword"
              class="input password_input"
              icon="icon-shurumima"
              placeholder="确认密码"
            />
            <Minput
              type="Number"
              v-model="forms.qq"
              class="input password_input"
              icon="icon-shurumima"
              placeholder="QQ(找回密码的唯一凭证)"
            />
          </div>
          <div class="submit_box">
            <MButton
              class="submit"
              :loading="loading"
              :disabled="!canISubmit"
              @click.native="register()"
            >
              注&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;册
            </MButton>
          </div>
        </div></transition
      >
    </div>
  </div>
</template>

<script>
import bgimg from "../assets/login_bg.png";
import Minput from "../components/common/Input.vue";
import MButton from "../components/common/Button.vue";
import { login, register } from "@/api/user";
import { setToken } from "@/utils/role";
export default {
  components: { Minput, MButton },
  name: "Login",
  data() {
    return {
      bgimg: bgimg,
      islogin: true,
      form_type: "login",
      loading: false,
      forms: {
        username: "wankong",
        password: "123456",
        repassword: "",
        qq: "",
      },
    };
  },
  watch: {
    islogin: function () {
      console.log("改变了登录");
    },
  },
  computed: {
    // 监听输入框是否已经全部符合条件？
    canISubmit: function () {
      let items = this.islogin
        ? ["username", "password"]
        : Object.keys(this.forms);
      let flag = true;
      items.forEach((item) => {
        flag = this.forms[item] != "";
      });
      if (this.islogin) {
        return flag;
      }
      flag =
        this.forms.password == this.forms.repassword && this.forms.qq != "";
      return flag;
    },
  },
  methods: {
    login() {
      this.loading = true;
      login({
        username: this.forms.username,
        password: this.forms.password,
      }).then(
        (res) => {
          if (res.code !== 200) {
            this.loading = false;
            this.$tip.danger(res.msg, 1500);
          }
          this.loading = false;
          this.$store;
          this.$store.commit("upUserInfo", res.data.info);
          setToken(res.data.token);
          this.$tip.success("登录成功", 1500);
          this.$router.push({ name: "User" });
        },
        (err) => {
          this.loading = false;
          this.$tip.danger(err.msg, 1500);
        }
      );
    },
    register() {
      this.loading = true;
      register(this.forms).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.$tip.success("注册成功", 1500);
        } else {
          this.$tip.danger(res.msg, 1500);
        }
      });
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: 0% 0% / cover no-repeat;
}
.footer {
  position: absolute;
  bottom: 1rem;
  width: 100%;
  left: 0;
}

.login_box {
  padding: 3rem;
  position: absolute;
  right: 100px;
  top: 50%;
  transform: translateY(-66.7%);
  width: 600px;
  border-radius: 10px;
  background: #fff;
}
.submit {
  margin-top: 1rem;
  background: #008ffa;
  cursor: pointer;
  color: #fff;
  &:disabled {
    background: #80ceff;
  }
}
.link {
  color: #008ffa;
}
.forms {
  margin-top: 40px;
}
.tips {
  margin: 1rem 0;
  cursor: pointer;
  opacity: 0.8;
  .link {
    cursor: pointer;
    &:hover {
      border-bottom: 1px solid #008ffa;
    }
  }
}
.lost-pwd {
  text-align: right;
  &:hover {
    color: #008ffa;
  }
}
</style>
